module.exports = __webpack_public_path__ + "img/p36.99b54240.png";